import { makeStyles } from "@material-ui/core";

export const useGlobalStyles = makeStyles((theme) => {
  const baseLink = {
    borderRadius: "4px",
    padding: "2px 1px",

    color: theme.palette.primary.main,
    textDecoration: "none",
    verticalAlign: "baseline",
    "&:hover": {
      color: theme.palette.primary.light,
    },
  };

  return {
    link: {
      ...baseLink,
    },
    focusedSelectedLink: {
      ...baseLink,
      color: theme.palette.primary.contrastText,
      background: theme.palette.primary.light,
      "&:hover": {
        color: theme.palette.getContrastText(theme.palette.primary.dark),
        background: theme.palette.primary.dark,
      },
    },
    compactParagraph: {
      marginTop: "0px",
      marginBottom: "0px",
    },
    firstBlock: {
      marginTop: "0px !important",
    },
    lastBlock: {
      marginBottom: "0px !important",
    },
    blockquote: {
      borderLeft: "4px solid",
      margin: "1em 0",
      paddingLeft: "1em",
      borderColor: theme.palette.primary.light,
    },
    compactBlockquote: {
      borderLeft: "3px solid",
      margin: "0 0",
      paddingLeft: "1em",
      borderColor: theme.palette.primary.light,
    },
    cardListItem: {
      paddingLeft: "0px",
      paddingRight: "0px",
      paddingTop: "4px",
      paddingBottom: "4px",
    },
    editableRichText: {},
    readOnlyRichText: {},
    postPreviewCard: {
      "&:hover": {
        backgroundColor: theme.palette.action.selected,
      },
      border: "0px",
      width: "100%",
      padding: theme.spacing(0.5),
      margin: theme.spacing(0.5),
    },
    cardEmptyPreview: {
      fontWeight: 200,
    },
    cardTitle: {
      fontWeight: 500,
      display: "inline",
    },
    mentionCardTitle: {
      fontWeight: 500,
      display: "inline",
      fontStyle: "italic",
    },
    postSubtitle: {
      fontWeight: 700,
      display: "inline",
      color: "rgba(0, 0, 0, 0.54)",
    },
    cardTitleDatePart: {
      color: "rgba(0, 0, 0, 0.54)",
      paddingLeft: "8px",
      display: "inline",
    },
    cardTitleDatePartNoPadding: {
      color: "rgba(0, 0, 0, 0.54)",
      display: "inline",
    },
    cardUsernamePart: {
      fontWeight: 300,
      color: "grey",
    },
    cardNoContent: {
      color: theme.palette.grey[500],
    },
    loadingIndicator: {
      position: "fixed",
      top: "30%",
      left: "50%",
    },
    searchSuggestionLine: {
      fontWeight: "bold",
      width: "100%",
      display: "inline",
      whiteSpace: "nowrap",
      lineHeight: "1.8em",
    },
    searchPrefixPart: {
      fontWeight: 700,
      color: theme.palette.primary.light,
    },
    alwaysBreakWord: {
      overflowWrap: "break-word",
      wordWrap: "break-word",
      wordBreak: "break-word",
    },
  };
});
